import { mapValues } from "lodash"
import ApiError from "./api.error"

interface Headers {
  [key: string]: string
}

interface Payload {
  body?: any
  headers?: Headers
}

interface TypedObject<T> {
  [key: string]: T
}

export enum Method {
  Get = "GET",
  Post = "POST",
  Patch = "PATCH",
  Delete = "DELETE",
}

export const createQuery = (object: TypedObject<any>) =>
  new URLSearchParams(
    mapValues(object, (property) => property.toString()) as TypedObject<string>
  ).toString()

export const createPath = (endpoint: string, query: TypedObject<any>) =>
  `${endpoint}?${createQuery(query)}`

const formatPayload = (payload: Payload) => ({
  ...payload,
  body: JSON.stringify(payload.body),
})

const getResponse = async (method: Method, path: string, payload: Payload) => {
  const response = await fetch(path, {
    method,
    ...formatPayload(payload),
  })

  if (!response.ok) {
    const body = await response.json()
    throw new ApiError(response, body)
  }

  if (response.status === 204) {
    return response.text()
  }

  return await response.json()
}

export const API = {
  get: async (path: string, payload: Payload = {}) =>
    getResponse(Method.Get, path, payload),
  post: async (path: string, payload: Payload = {}) =>
    getResponse(Method.Post, path, payload),
  patch: async (path: string, payload: Payload = {}) =>
    getResponse(Method.Patch, path, payload),
  delete: async (path: string, payload: Payload = {}) =>
    getResponse(Method.Delete, path, payload),
}
